import React from "react";
import styles from "./EditEventLogo.module.scss";
import { eventLogoComponents, TEventLogo, TEventLogoComponent } from "../../components/EventLogo/EventLogo";
import { EditEventLogoItem } from "./EditEventLogoItem/EditEventLogoItem";
import { getInitialEventLogoData } from "./utils/getInitialEventLogoData";
import { IWizardData } from "../../views/StartWizard/StartWizard";

interface IProps {
    eventLogo?: TEventLogo | null;
    setEventLogo: (eventLogo: TEventLogo | null) => void;
    wizardData?: IWizardData | null;
}

export const EditEventLogo = (props: IProps) => {
    const selectEventLogoComponent = (eventLogoComponent: TEventLogoComponent | null) => {
        props.setEventLogo(getInitialEventLogoData(eventLogoComponent, props.wizardData));
    };
    return (
        <div className={styles.wrapper}>
            <EditEventLogoItem
                currentEventLogoComponent={!props.eventLogo?.name ? null : props.eventLogo?.name}
                key={"none"}
                setEventLogoComponent={selectEventLogoComponent}
                eventLogoComponent={null}
            />
            {eventLogoComponents.map((eventLogoComponent) => (
                <EditEventLogoItem
                    currentEventLogoComponent={props.eventLogo?.name}
                    key={eventLogoComponent}
                    setEventLogoComponent={selectEventLogoComponent}
                    eventLogoComponent={eventLogoComponent}
                />
            ))}
        </div>
    );
};
